import { Element } from '../../../../common/html/element'
import { STATUS_COLOR } from '../../../constant'

export const CustomTdStatus = ({ val }) => {
  const { activeStatusName, activeStatusId } = val

  return (
    <Element
      elementName="span"
      style={{
        fontSize: 10,
        backgroundColor: STATUS_COLOR[activeStatusId],
        padding: '0 4px',
        color: '#ffffff',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
      }}
    >
      {activeStatusName}
    </Element>
  )
}
